import React, { createContext, useContext, useState, useEffect } from "react";
import { normalizeRole } from "../utils/roleUtils";

interface RoleContextProps {
  role: string;
  setRole: (role: string) => void;
  isRoleLoading: boolean;
}

const RoleContext = createContext<RoleContextProps | undefined>(undefined);

export const RoleProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // Load role from localStorage if available
  const [role, setRole] = useState<string>(
    normalizeRole(localStorage.getItem("userRole"))
  );
  const [isRoleLoading, setIsRoleLoading] = useState<boolean>(true);

  // Initialize role loading state
  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
    if (storedRole) {
      setRole(normalizeRole(storedRole));
    }
    setIsRoleLoading(false);
  }, []);

  // Save role to localStorage when it changes
  useEffect(() => {
    if (role) {
      localStorage.setItem("userRole", normalizeRole(role));
    }
  }, [role]);

  return (
    <RoleContext.Provider value={{ role, setRole, isRoleLoading }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = (): RoleContextProps => {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return context;
};
